import { z } from 'zod';
import { UuidSchema } from './ids';

const TextAnswer = z.object({ answer_type: z.literal('text'), value: z.string().max(8192) }).strict();
const SingleChoiceAnswer = z.object({ answer_type: z.literal('single_choice'), option_id: UuidSchema.nullable().default(null) }).strict();
const CheckboxesAnswer = z.object({ answer_type: z.literal('checkboxes'), option_ids: z.array(UuidSchema).default([]) }).strict();
const HiddenValueAnswer = z.object({ answer_type: z.literal('hidden_value'), value: z.string().max(2048) }).strict();

export const AnswerSchema = z.discriminatedUnion('answer_type', [TextAnswer, SingleChoiceAnswer, CheckboxesAnswer, HiddenValueAnswer]);
export type Answer = z.infer<typeof AnswerSchema>;

export const SubmissionSchema = z
  .object({
    schema_version: z.literal(1).default(1),
    form_id: UuidSchema,
    revision_id: UuidSchema,
    operation_id: UuidSchema,
    // Zod's record schema has no `.max()` cardinality API. Keep this
    // checked-consumer bound explicit so it stays aligned with Pydantic's
    // `Field(max_length=200)` rather than silently accepting an unbounded map.
    answers_by_block_id: z.record(UuidSchema, AnswerSchema).superRefine((answers, context) => {
      if (Object.keys(answers).length > 200) {
        context.addIssue({ code: 'custom', message: 'answers_by_block_id must contain at most 200 answers' });
      }
    }).default({}),
  })
  .strict();
export type Submission = z.infer<typeof SubmissionSchema>;
